import type { IntlShape } from 'react-intl';

import type { PermissionMode } from '../types';

export const desktopPermissionGateTitle = (
  intl: IntlShape,
  mode: PermissionMode
): string => {
  switch (mode) {
    case 'recording':
      return intl.formatMessage({
        defaultMessage: 'Permissions needed to record',
        id: 'uxJEXvn6cI',
        description:
          'Desktop permission gate title when recording permissions are missing',
      });
    case 'computer_use':
      return intl.formatMessage({
        defaultMessage: 'Permissions needed for desktop tasks',
        id: 'GkIwLeBOao',
        description:
          'Desktop permission gate title when computer-use permissions are missing',
      });
    default: {
      const exhaustive: never = mode;
      return exhaustive;
    }
  }
};

export const desktopPermissionGateDescription = (
  intl: IntlShape,
  mode: PermissionMode
): string => {
  switch (mode) {
    case 'recording':
      return intl.formatMessage({
        defaultMessage:
          'Grant the permissions below in System Settings, then try recording again.',
        id: 'nsyAemOBTG',
        description:
          'Desktop permission gate body when recording permissions are missing',
      });
    case 'computer_use':
      return intl.formatMessage({
        defaultMessage:
          'Grant the permissions below in System Settings, then restart Heidi and try the desktop task again.',
        id: 'ggM2YuPkVr',
        description:
          'Desktop permission gate body when computer-use permissions are missing',
      });
    default: {
      const exhaustive: never = mode;
      return exhaustive;
    }
  }
};
